export default __webpack_public_path__ + "static/media/add-client-example.5d6f9538.png";